
const ProgressBar = (props) => {
    const style = {
        width: props.percent + "%"
    };
    return (
        <>
            <p className="lead align-center">
                <strong>({style.width})</strong>
            </p>
            <div className="progress progress-lg">
                <div className="progress-bar progress-bar-striped progress-bar-animated bg-success"
                     role="progressbar" aria-valuenow={props.percent} aria-valuemin="0" aria-valuemax="100" style={style}> <strong> </strong></div>
            </div>
        </>
    );
}

export default ProgressBar;